import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/d/src/uu-data-dict/uu-data-dict/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "waardes-samenvoegen-schrijfwijzen-samenvoegen"
    }}>{`Waardes samenvoegen (Schrijfwijzen samenvoegen)`}</h1>
    <p>{`Hoe voeg je verschillende schrijfwijzen voor 'Commerciële verhuur' samen?`}</p>
    <p><img alt="Verschillende schrijfwijzen voor 'Commerci\xEBle verhuur'" src={require("../../public/powerbi-merge-values-before.png")} />{` `}</p>
    <p>{`In dit voorbeeld voegen we verschilende schrijfwijzen voor 'Commerciële verhuur' samen, in de het veld `}<inlineCode parentName="p">{`EvenementType`}</inlineCode>{` in de tabel `}<inlineCode parentName="p">{`Evenement`}</inlineCode>{`.`}</p>
    <ul>
      <li parentName="ul">{`Klik in het menu op `}<em parentName="li">{`Edit Queries`}</em>{`,`}</li>
      <li parentName="ul">{`klik in `}<em parentName="li">{`Queries`}</em>{` (links op het scherm) op de  tabel (in dit voorbeeld `}<inlineCode parentName="li">{`Evenement`}</inlineCode>{`),`}</li>
      <li parentName="ul">{`zoek de kolom op (in dit voorbeeld `}<inlineCode parentName="li">{`EvenementType`}</inlineCode>{`),`}</li>
      <li parentName="ul">{`klik met rechts op een waarde in de kolom, en kies `}<em parentName="li">{`Replace Values...`}</em></li>
    </ul>
    <p><img alt="Verschillende schrijfwijzen voor 'Commerci\xEBle verhuur'" src={require("../../public/powerbi-merge-values-replace-1.png")} />{` `}</p>
    <ul>
      <li parentName="ul">{`Vul bij 'Value To Find' in welke waarde (schrijfwijze) je wilt vervangen,`}</li>
      <li parentName="ul">{`vul bij 'Replace With' met welke waarde je wilt vervangen,`}</li>
      <li parentName="ul">{`klik op `}<em parentName="li">{`OK`}</em></li>
    </ul>
    <p><img alt="Verschillende schrijfwijzen voor 'Commerci\xEBle verhuur'" src={require("../../public/powerbi-merge-values-replace-2.png")} />{` `}</p>
    <ul>
      <li parentName="ul">{`Klik in het menu op `}<em parentName="li">{`Close & Apply`}</em></li>
    </ul>
    <p><img alt="Verschillende schrijfwijzen voor 'Commerci\xEBle verhuur'" src={require("../../public/powerbi-merge-values-apply.png")} />{` `}</p>
    <p>{`De schrijfwijze is nu vervangen, en eventuele tellingen zijn bijgewerkt:`}</p>
    <p><img alt="Verschillende schrijfwijzen voor 'Commerci\xEBle verhuur'" src={require("../../public/powerbi-merge-values-after.png")} />{` `}</p>
    <p>{`Herhaal dit voor de overige schrijfwijzen.`}</p>
    <ul>
      <li parentName="ul">{`Het is niet nodig om na elke schrijfwijze op `}<em parentName="li">{`Close & Apply`}</em>{` te klikken.`}</li>
      <li parentName="ul">{`Let goed op hoofdletters, spaties, en accenten.`}</li>
      <li parentName="ul">{`Het kan zijn dat er na het samenvoegen nieuwe schrijfwijzen opduiken. Deze werden eerder door Power BI automatisch samengevoegd. Vervang ook deze nieuwe schrijfwijzen.`}</li>
    </ul>
    <p><img alt="Verschillende schrijfwijzen voor 'Commerci\xEBle verhuur'" src={require("../../public/powerbi-merge-values-after-all.png")} />{` `}</p>
    <p>{`Alle schrijfwijzen zijn nu samengevoegd naar 'Commerciële verhuur'.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      